import React from 'react';
import AuthService from './authService.js';
import EndOfMonthItem from '../Domain/EndOfMonthItem.js';
import SearchParams from '../Elements/SearchParams';
import EndOfMonthSearchParams from '../Contents/EndOfMonth/EndOfMonthSearchParams';

export default class EndOfMonthService extends React.Component {
  static GetEndOfMonthDates() {
    const authService = AuthService.getInstance();

    let url = `/api/OpenAiChat/GetEndOfMonthDates`;
    url += '?clearCache=true';
    return authService.CallBackendFunction(url);
  }

  static GetAllItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, EndOfMonthSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/OpenAiChat/GetEomBySearchParams/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertEndOfMonthItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new EndOfMonthItem(item));
    }
    return [];
  }

  static ToggleEOMApproval(selectedItem) {
    const url = 'api/OpenAiChat/ToggleEOMApproval/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(selectedItem));
  }

  static EditEndOfMonth(selectedItem) {
    const url = 'api/OpenAiChat/UpdateEndOfMonthItem/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(selectedItem));
  }
}
